import React from 'react'
import { graphql } from 'gatsby'
import FaqDetails from '../components/faq/FaqDetails'
import FaqContact from '../components/faq/FaqContact'
import SEO from '../components/SEO'

import { useSchemaForLD } from '../hooks/useSchemaForLD'

const Faq = ({
  location,
  data: {
    contentfulFaqPage: {
      title,
      image,
      firstSectionTitle,
      firstSectionAccordion,
      secondSectionTitle,
      secondSectionAccordion,
      contactBackground,
      contactText,
      thirdSectionTitle,
      thirdSectionAccordion,
      fourthSectionTitle,
      fourthSectionAccordion,
      seoTitle,
      seoDescription,
    },
  },
}) => {
  return (
    <>
      <SEO
        isPage
        location={location}
        title={seoTitle}
        description={seoDescription}
        pageCategory={'FAQ'}
        referrer={location.state?.referrer}
        schemas={[
          useSchemaForLD('faq', {
            firstSectionAccordion: firstSectionAccordion,
            secondSectionAccordion: secondSectionAccordion,
            thirdSectionAccordion: thirdSectionAccordion,
            fourthSectionAccordion: fourthSectionAccordion,
          }),
        ]}
      />

      <FaqDetails
        title={title}
        image={image}
        firstSectionTitle={firstSectionTitle}
        firstSectionAccordion={firstSectionAccordion}
        secondSectionTitle={secondSectionTitle}
        secondSectionAccordion={secondSectionAccordion}
        thirdSectionTitle={thirdSectionTitle}
        thirdSectionAccordion={thirdSectionAccordion}
        fourthSectionTitle={fourthSectionTitle}
        fourthSectionAccordion={fourthSectionAccordion}
      />
      <FaqContact
        contactBackground={contactBackground}
        contactText={contactText}
      />
    </>
  )
}

export const FaqQuery = graphql`
  query Faq($id: String!) {
    contentfulFaqPage(id: { eq: $id }) {
      seoTitle
      seoDescription
      contactBackground {
        title
        fluid(sizes: "(max-width: 100vw) 100vw, 100vw") {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      contactText {
        raw
      }
      title
      image {
        fluid(sizes: "(max-width: 1023px) 100vw, 51vw") {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      firstSectionTitle
      firstSectionAccordion {
        title
        content {
          references {
            ... on ContentfulAsset {
              __typename
              contentful_id
              file {
                url
              }
              description
            }
            ... on ContentfulAccordionLink {
              contentful_id
              slug
            }
            ... on ContentfulTextPage {
              contentful_id
              slug
            }
            ... on ContentfulAboutPage {
              contentful_id
              slug
            }
            ... on ContentfulTechnologyPage {
              contentful_id
              slug
            }
          }
          raw
        }
      }
      secondSectionTitle
      secondSectionAccordion {
        title
        content {
          references {
            ... on ContentfulAsset {
              __typename
              contentful_id
              file {
                url
              }
              description
            }
            ... on ContentfulAccordionLink {
              contentful_id
              slug
            }
            ... on ContentfulTextPage {
              contentful_id
              slug
            }
            ... on ContentfulAboutPage {
              contentful_id
              slug
            }
            ... on ContentfulTechnologyPage {
              contentful_id
              slug
            }
          }
          raw
        }
      }
      thirdSectionTitle
      thirdSectionAccordion {
        title
        content {
          references {
            ... on ContentfulAsset {
              __typename
              contentful_id
              file {
                url
              }
              description
            }
            ... on ContentfulAccordionLink {
              contentful_id
              slug
            }
            ... on ContentfulTextPage {
              contentful_id
              slug
            }
            ... on ContentfulAboutPage {
              contentful_id
              slug
            }
            ... on ContentfulTechnologyPage {
              contentful_id
              slug
            }
          }
          raw
        }
      }
      fourthSectionTitle
      fourthSectionAccordion {
        title
        content {
          references {
            ... on ContentfulAsset {
              __typename
              contentful_id
              file {
                url
              }
              description
            }
            ... on ContentfulAccordionLink {
              contentful_id
              slug
            }
            ... on ContentfulTextPage {
              contentful_id
              slug
            }
            ... on ContentfulAboutPage {
              contentful_id
              slug
            }
            ... on ContentfulTechnologyPage {
              contentful_id
              slug
            }
          }
          raw
        }
      }
    }
  }
`

export default Faq
